import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupWindowStaticTitle from "../components/PiPopupWindowStaticTitle";
import ClearCharacterPartsPreviewBody from "./ClearCharacterPartsPreviewBody";

export default function ClearCharacterPartsPreview() {
  return (
    <PiPopupWindowPreview
      title={<PiPopupWindowStaticTitle title="Clear Character Parts" />}
      body={<ClearCharacterPartsPreviewBody />}
      size="large"
    />
  );
}
